<template>
  <div v-if="!isTargetFixed" class="move-from-excluded-confirmation-popup">
    <popup :buttons="buttonOptions"
           :back-action="back">
      <template v-slot:title>
        <span class="selected-category" :class="selectedCategory.cashflowCategory">להחזיר את ה{{ incomeOrExpense }} הזו לתזרים של החודש?</span>
      </template>
      <template v-slot:content>
        <div class="explanation">
          <div class="warning">זה אומר שה{{ incomeOrExpense }} הזאת <span class="bold">תופיע בחישוב התזרים של החודש!</span></div>
          <div v-if="isIncomeCategory">הכנסה שהיא חלק מחישוב התזרים היא הכנסה שהתכוונת לממן איתה את ההוצאות של החודש.</div>
          <div v-else>הוצאה שהיא חלק מחישוב התזרים היא הוצאה שהתכוונת לממן מההכנסות של אותו החודש.</div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="cancel">
          <div class="delete-text" v-on:click="close">ביטול</div>
        </div>
      </template>
    </popup>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import BaseUI from 'base-ui';
import cashflowViewConsts from '@/constants/cashflow-view';
import ChangeTransactionCategoryPopup from './ChangeTransactionCategoryPopup.vue';
import MoveFromExcludedSummaryPopup from './MoveFromExcludedSummaryPopup.vue';
import Segment from '../../../../../../../../../../Segment';
import MoveToFixedConfirmationPopup from './MoveToFixedConfirmationPopup.vue';

export default {
  name: 'MoveFromExcludedConfirmationPopup',
  components: {
    Popup: BaseUI.Popup,
  },
  created() {
    Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_Shown', {
      businessName: this.transaction.businessName,
      expenseCategory: this.transaction.expense,
      isIncomeCategory: this.isIncomeCategory,
      transactionId: this.transaction.transactionId,
    });
    if (this.isTargetFixed) {
      this.$emit('close');
      this.openModal({
        component: MoveToFixedConfirmationPopup,
        props: {},
      });
    }
  },
  computed: {
    ...mapState('editTransaction', ['transaction']),
    ...mapGetters('editTransaction', [
      'selectedCategory', 'originalCategory', 'ENRICHMENT_INPUT_TYPES', 'categoryToVariant', 'isIncomeCategory', 'incomeOrExpense',
    ]),
    buttonOptions() {
      return [{
        title: 'כן, להחזיר לתזרים',
        size: 'slim',
        action: () => this.onSave(),
        variant: 'primary',
      }];
    },
    isTargetFixed() {
      return this.selectedCategory.cashflowCategory === cashflowViewConsts.CASHFLOW_CATEGORIES.FIXED_INCOME;
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    back() {
      Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_BackClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
        isIncomeCategory: this.isIncomeCategory,
        transactionId: this.transaction.transactionId,
      });
      this.$emit('close');
      this.openModal({
        component: ChangeTransactionCategoryPopup,
        props: {},
      });
    },
    onSave() {
      Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_AnswerClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
        isIncomeCategory: this.isIncomeCategory,
        transactionId: this.transaction.transactionId,
      });
      this.$emit('close');
      this.openModal({
        component: MoveFromExcludedSummaryPopup,
        props: {},
      });
    },
    close() {
      Segment.trackUserInteraction('MoveFromExcludedConfirmationPopup_CloseClicked', {
        businessName: this.transaction.businessName,
        expenseCategory: this.transaction.expense,
        isIncomeCategory: this.isIncomeCategory,
        transactionId: this.transaction.transactionId,
      });
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../../../../../../../../scss/category-color-mixins';

  .move-from-excluded-confirmation-popup {

    .explanation {
      line-height: 16px;
      white-space: pre-line;
      .warning {
        color: $riseup_danger_red;
        margin-bottom: 16px;
        .bold {
          font-weight: bold;
        }
      }
    }

    .cancel {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;

      .delete-text {
        color: $riseup_black;
        font-size: 18px;
        font-weight: normal;
      }
    }
  }

</style>
